// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  ${(props) =>
    `
  .coupon_header {
    display:flex;
    align-items: center;
  }
  .coupon__list{
    ${!props.isNewCouponUXWithoutTabEnabled && `border-top: 1px solid #D8D8D8`};
    overflow: hidden;
  }
  .on-hold-notification {
    box-sizing: border-box;
    display: inline-block;
    width: 16px;
    height: 16px;
    left: 0;
    top: 8px;
    background: #F7971F;
    border: 1px solid #F7971F;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    margin: 0 5px 0 0;
    padding: 0px 0;
    font-size: 12px;
  }
  .couponList__header__button {
    border: none;
    background: transparent;
    cursor: pointer;
    padding-right:0px;
    margin-right:${props.theme.spacing.ELEM_SPACING.SM};
    padding-bottom: 0px;
    text-transform: capitalize;
    padding-left: 0px;
  }
  .couponList__header__button:focus {
    background: transparent;
  }
  .couponList__header__active {
    position:relative;
    border-bottom:3px solid #4B9FDD;
    &:after {

    position:absolute
    width: 100%;
    height: 3px;
    background: #4B9FDD;
    border-radius: 5px;
    top: 10px;
  }
}
`}
  .coupon_list {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-left: ${(props) => (props.spc ? '15px' : '0px')};
    }
  }
  .alignTop.alignTop {
    top: 15px;
  }

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    .coupon_list {
      margin-left: ${(props) => (props.spcBag ? '0px' : '14px')};
      margin-right: ${(props) => (props.spcBag ? '0px' : '14px')};
    }
  }

  ${(props) =>
    props.spc
      ? `
    .coupon_list {
      margin-left: 0px;
      margin-right: 0px;

      &.d-none {
        display: none;
      }

      & .couponCard__container {
        margin-bottom: ${props.theme.spacing.ELEM_SPACING.LRG};
      }
    }
  `
      : ''}

  .rewards-header {
    text-align: left;
  }

  .main-header-rewards {
    font-family: ${(props) => props.theme.fonts.tertiaryDemiBold};
  }
  .details-header {
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
    padding-top: 5px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
  }

  .couponsWrapperAccordian {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-left: ${(props) => (props.spc ? 0 : '-14px')};
      margin-right: ${(props) => (props.spc ? 0 : '-14px')};
    }
  }
  .collapsible-header {
    background-color: ${(props) => props.theme.colorPalette.white};

    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XL};

    ${(props) =>
      props.spc
        ? `
        padding: 0;
    `
        : ''}
  }
  .coupon-sec .collapsible-button,
  .collapsible-header {
    display: 'none';
  }
  .collapsible-icon {
    display: ${(props) => (props.spc ? 'block' : 'none')};
    top: ${(props) => (props.spc ? '26px' : props.theme.spacing.ELEM_SPACING.LRG)};
    right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .item-closed {
    ${(props) => props.spc && 'display:none;'}
  }
  .coupon_error_message {
    background-color: white;
    ${(props) =>
      props.spc
        ? `
      padding:15px;
      border:1px solid ${props.theme.colorPalette.red[500]};
      border-radius:8px;
      margin-top:16px;
      span{
        color:${props.theme.colorPalette.black};
        font-weight:normal;
      }
      @media ${props.theme.mediaQuery.mediumOnly} {
        width:95%;
        margin-top:24px;
      }
      `
        : ''}
  }
  .warning-icon {
    background-size: contain;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .coupon_error_message {
      ${(props) => (!props.spc ? `padding-bottom: ${props.theme.spacing.ELEM_SPACING.LRG};` : '')}
      img {
        padding-top: 0;
        padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      }
    }
  }
  .available_coupon {
    .cart-show-more-btn {
      padding-bottom: ${(props) => props.theme.spacing.LAYOUT_SPACING.SM};
    }
  }
  .coupon-sec {
    ${(props) =>
      !props.spc &&
      !props.isNewCouponPositionEnabled &&
      `margin-bottom: ${props.theme.spacing.ELEM_SPACING.MED};`}

    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 100%;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => !props.spc && `margin-bottom: ${props.theme.spacing.ELEM_SPACING.MED};`}
    }
  }
  .coupon_error_message_new {
    border: 1px solid ${(props) => props.theme.colorPalette.red[500]};
    border-radius: 8px;
    background-color: transparent;
    padding: 13px 0 13px 0;
    margin-top: 8px;
    ${(props) =>
      props.spc
        ? `width:275px; border-radius:6px;
    margin-right:12px;
    @media ${props.theme.mediaQuery.large} {
      margin-right:24px;
    }
    `
        : ''};
  }

  .apply-place-bucks-wrapper {
    ${(props) => (!props.spc ? `margin: 0 12px;` : `width:100%;margin-bottom: 20px;`)}
  }

  .apply-place-bucks-container {
    border: none;
    padding: 6px 12px 6px 16px;
    background-color: #eaffdb;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: capitalize;
    width: ${(props) => (props.spc ? '42%' : '100%')};

    @media (max-width: 480px) {
      /* For mobile devices */
      width: 100%;
    }
  }
  .apply-place-bucks-container:hover {
    border: none;
    background-color: #eaffdb;
  }
  .apply-place-bucks-container:focus {
    border: none;
    background-color: #eaffdb;
  }
  .place-bucks-apply-icon {
    transform: rotate(270deg);
    cursor: pointer;
  }
  .left-content {
    display: flex;
    align-items: center;
  }
  .error-message {
    margin-top: 8px;
    color: #c8102e;
    display: flex;
  }
`;

const crossTop = css`
  top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
`;

export { styles, crossTop };
